import {
    type GetSentMailByIdResponseType,
    type GetSentMailByIdRequestType
} from "./type";
import {
    request
} from "../request";

const getSentMailById = async (
    params: GetSentMailByIdRequestType
): Promise<GetSentMailByIdResponseType> => {
    return await request<GetSentMailByIdResponseType>(
        `/notification/getSentMailById?id=${params.id}`,
        {
            method: "GET"
        }
    );
};
export default getSentMailById;
